//
import { mapActions } from "vuex"

//
import { ModelDataTable, ModelForm } from "@/components/reusable_components/next"
import QueryModel from "@/models/General/GQuery"
import Translator from "@/services/translator"

//
import fields from "./fields"

//
export default {
    name: "query-create",
    components: {
        ModelDataTable,
        ModelForm,
    },
    computed: {

        /**
         * 
         */
        formProps () {
            return {
                fields,
            }
        },
    },
    data () {
        return {
            formData    : {},
            tableData   : [],
            tableHeaders: [],
            verified    : false,
        }
    },
    methods: {

        //
        ...mapActions( "MenuesModule", {
            setTitleTopBar: "setTitleTopBar",
        }),

        /**
         * 
         */
        error ( error ) {
            this.$toast.error( Translator( QueryModel, error.response.data ) )
        },

        /**
         * 
         */
        fetch () {
            QueryModel.modeler().find( this.$route.params.id ).then( this.setFormData )
        },

        /**
         * 
         */
        mapHeader ( header ) {
            return {
                text    : header,
                value   : header,
            }
        },

        /**
         * 
         */
        raw ( model ) {
            new QueryModel({ id: "run" }).rawQuery( model.query ).get().finally( this.$refs.form.setWait ).then( this.setTableData ).catch( this.error )
        },

        /**
         * 
         */
        redirect () {
            this.$router.push({ name: "query-list" })
        },

        /**
         * 
         */
        reset () {
            this.fetch()
        },

        /**
         * 
         */
        run () {
            this.$refs.form.setWait( true ).then( this.raw )
        },

        /**
         * 
         */
        setFormData ( model ) {
            this.formData = model.reset()
        },

        /**
         * 
         */
        setTableData ( res ) {
            this.tableHeaders   = Object.keys( res.slice().pop().result.data.slice().pop() || {} ).map( this.mapHeader )
            this.tableData      = res.slice().pop().result.data
            this.verified       = true
        },

        /**
         * 
         */
        submit () {
            this.$refs.form.setWait( true ).then( this.update )
        },

        /**
         * 
         */
        success () {
            this.$toast.success( "Consulta actualizada." )
        },

        /**
         * 
         */
        update ( model ) {
            model.toUpdate().save().then( this.success ).then( this.redirect ).catch( this.error ).then( this.$refs.form.setWait )
        },
    },
    beforeMount () {
        this.setTitleTopBar( "Crear consulta" )
    },
    mounted () {
        this.reset()
    }
}